let csrfToken = '';
export function setCSRFToken(value: string) { csrfToken = value; }
export async function adminFetch(input: RequestInfo | URL, init: RequestInit = {}) {
  const headers = new Headers(init.headers);
  if (init.method && init.method.toUpperCase() !== 'GET') headers.set('X-CSRF-Token', csrfToken);
  return fetch(input, { ...init, headers, credentials: 'same-origin' });
}
